import slideDown from '../util/slide-down';
import slideUp from '../util/slide-up';
import showElement from '../util/show-element';
import hideElement from '../util/hide-element';
import slideToggle from '../util/slide-toggle';
import throttle from '../util/throttle';

const selectors = {
  elements: {
    accordionHolder: '[data-accordion-holder]',
    accordion: '[data-accordion]',
    accordionToggle: '[data-accordion-toggle]',
    accordionBody: '[data-accordion-body]',
    accordionExpandValue: 'data-accordion-expand',
    accordionBlockValue: 'data-block-id',
  },
  classes: {
    open: 'is-open',
  },
};

const sections = {};

class GlobalAccordions {
  constructor(el) {
    this.container = el.container;
    this.accordion = this.container.querySelector(selectors.elements.accordion);
    this.accordionToggles = this.container.querySelectorAll(selectors.elements.accordionToggle);
    this.accordionTogglesLength = this.accordionToggles.length;
    this.accordionBody = this.container.querySelector(selectors.elements.accordionBody);

    if (this.accordionTogglesLength && this.accordionBody) {
      this.accordionEvents();
    }
  }

  accordionEvents() {
    this.accordionToggles.forEach((element) => {
      element.addEventListener(
        'click',
        throttle((event) => {
          event.preventDefault();
          const targetAccordionBody = element.parentElement.querySelector(selectors.elements.accordionBody);
          if (targetAccordionBody) {
            this.onAccordionToggle(element, targetAccordionBody);
          }
        }, 800)
      );
    });

    if (this.accordion.getAttribute(selectors.elements.accordionExpandValue) === 'true') {
      this.accordionToggles[0].classList.add(selectors.classes.open);

      showElement(this.accordionToggles[0].parentElement.querySelector(selectors.elements.accordionBody));
    }
  }

  closeOtherAccordions(element, slide = true) {
    let otherElements = [...this.accordionToggles];
    const holder = this.container.closest(selectors.elements.accordionHolder);
    if (holder) {
      otherElements = [...holder.querySelectorAll(selectors.elements.accordionToggle)];
    }

    otherElements.filter((otherElement) => {
      const otherElementAccordionBody = otherElement.parentElement.querySelector(selectors.elements.accordionBody);
      if (otherElement !== element && otherElement.classList.contains(selectors.classes.open) && otherElementAccordionBody) {
        this.onAccordionClose(otherElement, otherElementAccordionBody, slide);
      }
    });
  }

  onAccordionOpen(element, body, slide = true) {
    element.classList.add(selectors.classes.open);
    slideDown(body);

    this.closeOtherAccordions(element, slide);
  }

  onAccordionClose(element, body, slide = true) {
    element.classList.remove(selectors.classes.open);
    if (slide) {
      slideUp(body);
    } else {
      hideElement(body);
    }
  }

  onAccordionToggle(element, body) {
    element.classList.toggle(selectors.classes.open);
    slideToggle(body);

    this.closeOtherAccordions(element);

    element.dispatchEvent(
      new CustomEvent('theme:form:sticky', {
        bubbles: true,
        detail: {
          element: 'accordion',
        },
      })
    );
  }

  onBlockToggle(evt, blockSelect = true) {
    const targetAccordionToggle = this.container.querySelector(`${selectors.elements.accordionToggle}[${selectors.elements.accordionBlockValue}="${evt.detail.blockId}"]`);
    if (!targetAccordionToggle) return;
    const targetAccordionBody = targetAccordionToggle.parentElement.querySelector(selectors.elements.accordionBody);
    if (!targetAccordionBody) return;
    if (blockSelect) {
      this.onAccordionOpen(targetAccordionToggle, targetAccordionBody, false);
    } else {
      this.onAccordionClose(targetAccordionToggle, targetAccordionBody);
    }
  }

  onSelectToggle(sectionSelect = true) {
    if (this.accordionBody && this.accordionTogglesLength && this.accordionTogglesLength < 2) {
      if (sectionSelect) {
        this.onAccordionOpen(this.accordionToggles[0], this.accordionBody, false);
      } else {
        this.onAccordionClose(this.accordionToggles[0], this.accordionBody);
      }
    }
  }

  onSelect() {
    this.onSelectToggle(true);
  }

  onDeselect() {
    this.onSelectToggle(false);
  }

  onBlockSelect(evt) {
    this.onBlockToggle(evt, true);
  }

  onBlockDeselect(evt) {
    this.onBlockToggle(evt, false);
  }
}

const accordions = {
  onLoad() {
    sections[this.id] = new GlobalAccordions(this);
  },
  onSelect() {
    sections[this.id].onSelect();
  },
  onDeselect() {
    sections[this.id].onDeselect();
  },
  onBlockSelect(e) {
    sections[this.id].onBlockSelect(e);
  },
  onBlockDeselect(e) {
    sections[this.id].onBlockDeselect(e);
  },
};

export default accordions;
